import { configureStore } from "@reduxjs/toolkit";
import { planCreationReducer } from "@store/plan-creation/plan-creation-slice";
import * as Sentry from "@sentry/react";
import { appReducer } from "@store/app/app-slice";
import { devFeaturesReducer } from "@store/dev-features/dev-features-slice";
import { memberReducer } from "@store/member/member-slice";
import { companyReducer } from "@store/workspace/workspace-slice";
import { projectReducer } from "@store/project/project-slice";
import { userReducer } from "@store/user/user-slice";
import { plansReducer } from "@store/plans/plans-slice";

// When adding a new reducer here also add the corresponding reset action to the "resetStore" function.
const rootReducer = {
  company: companyReducer,
  member: memberReducer,
  project: projectReducer,
  app: appReducer,
  devFeatures: devFeaturesReducer,
  planCreation: planCreationReducer,
  plans: plansReducer,
  user: userReducer,
};

/**
 * Sentry's Redux enhancer. It captures all actions and state changes.
 * DOC: https://docs.sentry.io/platforms/javascript/guides/react/features/redux/
 */
const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options listed below. It should be updated to filter out sensitive user data
});

export const store = configureStore({
  reducer: rootReducer,
  enhancers: (getDefaultEnhancers) => {
    return getDefaultEnhancers().concat(sentryReduxEnhancer);
  },
});
